import * as React from 'react';
import PropTypes from 'prop-types';
import ListItemActionComponent from './list-item-action-component';

export default class ListItemActionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    this.props.onClick(event);
  }

  render() {
    return (<ListItemActionComponent {...this.props} onClick={this.handleClick} />)
  }
}

ListItemActionContainer.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/component/list/list-item-action/list-item-action-container.js